import React from 'react';
import PropTypes from 'prop-types';

const MDIcon = ({ icon, size = 24, className = '' }) => (
  <span className={`mdi mdi-${size}px mdi-${icon} ${className}`}/>);

MDIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
};

export default MDIcon;
